import DashboardPage from '@/features/dashboard/pages/page';
import Loading from '@/shared/components/loading/loading';
import { FC, lazy, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { GlobalFormModal } from '@/features/dashboard/components/global-form-modal/GlobalFormModal';

interface AppRootProps { }

const AppRoot: FC<AppRootProps> = () => {
    const location = useLocation();

    const Dashboard = lazy(async () => {
        const { Dashboard } = await import('@/features/dashboard/components/dashboard/dashboard');
        return { default: Dashboard };
    });

    

    return (
        <>
            <DashboardPage>
                {location.pathname === '/' && (
                    <Suspense fallback={<Loading />}>
                        <Dashboard />
                    </Suspense>
                )}
                <Outlet />
            </DashboardPage>
            <GlobalFormModal />
        </>
    );
};

export default AppRoot;
